import { createFileRoute } from '@tanstack/react-router';

import { PlansTab } from '../../../../components';

const Page = () => {
  const params = Route.useParams();
  return <PlansTab advisoryOrganizationId={params.advisoryOrganizationId} />;
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/'
)({
  component: Page
});
